'use strict';

import shellModule from './shell.module';
import './components/mx-action/mx-action.js';
import './components/mx-actions-dropdown/mx-actions-dropdown.js';
import './components/mx-command-palette/mx-command-palette.js';
import './components/mx-common-actions/mx-common-actions.js';
import './components/mx-extra-panel/mx-extra-panel-ctrl.js';
import './components/mx-extra-panel/mx-extra-panel-manager.js';
import './components/mx-horizontal-action-list/mx-horizontal-action-list.js';
import './components/mx-main-content-zone/mx-main-content-zone.js';
import './components/mx-relink-event/mx-relink-event.js';
import './components/mx-shell-avatar/mx-shell-avatar.js';
import './components/mx-shell-background-processes/mx-shell-background-processes.js';
import './components/mx-shell-breadcrumbs/mx-shell-breadcrumbs.js';
import './components/mx-shell-info-panel/mx-shell-info-panel-service.ts';
import './components/mx-shell-info-panel/mx-shell-info-panel.js';
import './components/mx-shell-left-sidebar/mx-shell-left-sidebar-service.js';
import './components/mx-shell-left-sidebar/mx-shell-left-sidebar.js';
import './components/mx-shell-operation-monitor/mx-shell-operation-monitor.js';
import './components/mx-shell-search/mx-search-keyboard-manager.js';
import './components/mx-shell-search/mx-shell-search.js';
import './components/mx-shell-sidebar/mx-shell-sidebar.js';
import './components/mx-shell-toolbar/mx-shell-toolbar-app-switcher-controller.js';
import './components/mx-shell-toolbar/mx-shell-toolbar-manager.js';
import './components/mx-shell-toolbar/mx-shell-toolbar.js';
import './components/mx-search-grouped-context-list/mx-search-grouped-context-list.js';
import './components/mx-shell-unified-search/mx-shell-unified-search.js';
import './components/mx-shell-unified-search/mx-global-search-manager.js';
import './components/mx-shell-user-menu/mx-shell-user-menu.js';
import './components/mx-shell/mx-shell.component.js';
import './components/mx-side-layout/mx-side-layout.js';
import './components/mx-toolbar-actions/mx-toolbar-actions.js';
import './components/mx-toolbar-actions/mx-try-new-look-action/mx-try-new-look-action';
import './components/mx-view/mx-view.js';
import './components/mx-wizard/mx-wizard-roadmap.js';
import './components/mx-wizard/mx-wizard.js';
import './layouts/page-not-found/page-not-found-controller.js';
import './layouts/unauthorized/unauthorized.js';
import './model/action';
import './model/details-view.ts';
import './model/display-modes.js';
import './model/enumerations.js';
import './model/object.js';
import './model/search-context.js';
import './model/view.ts';
import './model/process-item.ts';
import './model/wizard/wizard-button.js';
import './model/wizard/wizard-page.js';
import './model/wizard/wizard-roadmap-step.js';
import './model/wizard/wizard-roadmap.js';
import './model/wizard/wizard-view.ts';
import './model/wizard/wizard.js';
import './services';

export default shellModule;
